import React from 'react';
import { Helmet } from 'react-helmet-async';

const someDefinedVariable = "Customer Support & Help Center | DocuSafe";

const CustomerSupport = () => {
    return (
        <>
            <Helmet>
                <title>{someDefinedVariable || "Default Title"}</title>
                <meta name='description' content='Get expert support for DocuSafe services. Contact our customer service team for assistance with e-signatures, document management, and technical issues. We are here to help!' />
                <meta name='keywords' content='customer support, help center, technical support, e-signature help, document management support, customer service, contact support, DocuSafe support' />
            </Helmet>
            <section className="policy-container">
                <div className="container">
                    <div className="policy-section">
                        <h1 className="policy-title">Customer Support</h1>
                        <div className="policy-intro">
                            <p className="policy-text">
                                At DocuSafe, we are committed to providing exceptional customer support. Our dedicated team is here to assist you with any questions, concerns, or technical issues you may encounter while using our services.
                            </p>
                        </div>
                    </div>

                    <div className="policy-section">
                        <h3 className="policy-subtitle">Contact Information</h3>
                        <div className="policy-card">
                            <h4 className="policy-card-title">Support Channels</h4>
                            <ul className="policy-list">
                                <li className="policy-text">
                                    <strong>Email Support:</strong> <a href="mailto:support@docusafe.ai" className="policy-link">support@docusafe.ai</a>
                                </li>
                                <li className="policy-text">
                                    <strong>Phone Support:</strong> +65 1234 5678 (Monday to Friday, 9 AM to 6 PM SGT)
                                </li>
                                <li className="policy-text">
                                    <strong>Live Chat:</strong> Available 24/7 through our website
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="policy-section">
                        <h3 className="policy-subtitle">Support Services</h3>
                        <div className="policy-card">
                            <h4 className="policy-card-title">Technical Support</h4>
                            <p className="policy-text">
                                Our technical support team is available to help you with:
                            </p>
                            <ul className="policy-list">
                                <li className="policy-text">Platform navigation and usage</li>
                                <li className="policy-text">E-signature process assistance</li>
                                <li className="policy-text">Document management issues</li>
                                <li className="policy-text">Account setup and configuration</li>
                                <li className="policy-text">Integration support</li>
                            </ul>
                        </div>

                        <div className="policy-card">
                            <h4 className="policy-card-title">Account Support</h4>
                            <p className="policy-text">
                                For account-related inquiries, we can assist with:
                            </p>
                            <ul className="policy-list">
                                <li className="policy-text">Account creation and setup</li>
                                <li className="policy-text">Billing and subscription management</li>
                                <li className="policy-text">User access and permissions</li>
                                <li className="policy-text">Security settings and preferences</li>
                            </ul>
                        </div>
                    </div>

                    <div className="policy-section">
                        <h3 className="policy-subtitle">Response Times</h3>
                        <div className="policy-card">
                            <p className="policy-text">
                                We strive to respond to all inquiries as quickly as possible:
                            </p>
                            <ul className="policy-list">
                                <li className="policy-text">Email: Within 24 hours</li>
                                <li className="policy-text">Phone: Immediate during business hours</li>
                                <li className="policy-text">Live Chat: Real-time response</li>
                            </ul>
                        </div>
                    </div>

                    <div className="policy-section">
                        <h3 className="policy-subtitle">Feedback and Suggestions</h3>
                        <div className="policy-card">
                            <p className="policy-text">
                                We value your feedback and continuously work to improve our services. Please share your suggestions or report any issues you encounter.
                            </p>
                            <p className="policy-text">
                                For feedback or suggestions, please email us at <a href="mailto:feedback@docusafe.ai" className="policy-link">feedback@docusafe.ai</a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CustomerSupport;
